import { BaseBundle } from "../../BaseBundle";
import { LoginViewModel } from "./LoginViewModel";

class LoginBundle extends BaseBundle {
    private static instance: LoginBundle | null = null;
    private loginViewModel = new LoginViewModel(window);

    constructor() {
        super(false);

        this.addDOMContentLoadedEventHandlers();
    }

    private addDOMContentLoadedEventHandlers(): void {
        document.addEventListener("DOMContentLoaded", () => this.applyBindings());
        document.addEventListener("DOMContentLoaded", () => this.checkLogin());
    }

    private applyBindings(): void {
        ko.applyBindings(this.loginViewModel);
    }

    private checkLogin(): void {
        const isLoginDialogRendered = $('#loggedin-dialog').length > 0;
        if (isLoginDialogRendered) {
            this.loginViewModel.toonVraagOpnieuwInloggen();
        }
    }

    public static Load(): void {
        if (LoginBundle.instance === null) {
            LoginBundle.instance = new LoginBundle();
        }
    }
}

LoginBundle.Load();
